<template>
  <div data-v-f531b812="" class="app app-ti_green metransRecord">
    <div data-v-8a75a126="" data-v-f531b812="" class="header">
      <div data-v-8a75a126="" class="header__top-wrapper">
        <div data-v-8a75a126="" class="van-nav-bar van-nav-bar--fixed fixed-top rounded-corners nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis">{{ $t('recharge_info') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="height:40px"></div>
    <div data-v-334775a8="" data-v-f531b812="" class="wrapper green-wrapper">
      <!-- 金额信息卡片 -->
      <div data-v-334775a8="" class="PayInfoTime green-PayInfoTime">
        <div class="PayAmount">
          <span class="currency-symbol">¥</span>
          <span class="Amount">{{ payInfo.info ? payInfo.info.amount : 0 }}</span>
        </div>
        
        <!-- USDT金额和汇率行 -->
        <div v-if="payInfo.cardlist" class="usdt-info-row">
          <div v-if="payInfo.info && payInfo.info.real_money" class="UsdtAmount">
            <span class="usdt-icon">💎</span>
            <span>≈ {{ payInfo.info.real_money }} USDT</span>
          </div>
          <div v-if="payInfo.info && payInfo.info.usdtrate" class="ExchangeRate">
            <span>1 USDT = {{ payInfo.info.usdtrate }} CNY</span>
          </div>
        </div>
        
        <div class="Countdown">
          <div class="countdown-box">
            <span class="countdown-label">{{ $t('please_complete_payment_within') }}</span>
            <span class="countdown-time">{{ m >= 10 ? m : `0${m}` }}：{{ s >= 10 ? s : `0${s}` }}</span>
          </div>
        </div>
        <div class="auto-credit-tip">{{ $t('auto_credit_after_payment') }}</div>
        <div class="contact-tip">{{ $t('contact_customer_service_if_issue') }}<span class="contact-customer" @click="$parent.openKefu"> {{ $t('customer_service') }} </span>{{ $t('confirm') }}</div>
      </div>

      <!-- 交易详情卡片 -->
      <div data-v-334775a8="" class="transaction-detail bg">
        <!-- USDT收款地址 -->
        <div v-if="payInfo.cardlist" class="detail-item address-item">
          <div class="detail-label">{{ $t('receiving_address') }}</div>
          <div class="detail-value address-value">
            <span class="address-text">{{ payInfo.cardlist.wallet_address || '6666666666666666666666' }}</span>
            <span @click="doCopy(payInfo.cardlist.wallet_address || '6666666666666666666666')" class="copy-btn">{{ $t('copy') }}</span>
          </div>
        </div>

        <div class="detail-item">
          <div class="detail-label">{{ $t('order_no') }}</div>
          <div class="detail-value">
            <span class="order-text">{{ payInfo.deposit_no }}</span>
          </div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">{{ $t('transaction_time') }}</div>
          <div class="detail-value">{{ payInfo.info ? payInfo.info.created_at : '' }}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">{{ $t('recharge_method') }}</div>
          <div class="detail-value method-value">{{ payInfo.info ? payInfo.info.paytype : '' }}</div>
        </div>
        
        <div v-if="payInfo.cardlist" class="detail-item">
          <div class="detail-label">{{ $t('wallet_protocol') }}</div>
          <div class="detail-value protocol-value">{{ payInfo.cardlist.category || 'TRC20' }}</div>
        </div>
        
        <!-- 二维码 -->
        <div v-if="payInfo.cardlist && (payInfo.cardlist.pay_qrcode || payInfo.cardlist.payimg)" class="qrcode-wrapper">
      <!--    <div class="qrcode-label">{{ $t('scan_qrcode') || '扫码支付' }}</div>  -->
          <img 
            :src="payInfo.cardlist.pay_qrcode || payInfo.cardlist.payimg" 
            class="qrcode-image"
            alt=""
          />
        </div>
      </div>
      
      <div data-v-334775a8="" class="footer">
        <div data-v-334775a8="" class="goback-button" @click="$parent.goNav('/#/')">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAMAAADpVnyHAAAAPFBMVEVHcEwLqoUPqIUPqIYIp4cAr4AOqIYMp4cOp4UNp4UPqIYPqIYPqIYOp4YOqIUPqIYOqIUPp4UNqYYPqIanHmPRAAAAE3RSTlMAMO/wIBBwQIBg0MDfoLCvkOBQvn0j8QAAAJFJREFUGBl1wYkBwiAQBMAlPHdAXrf/XgVJFA3OoOMi/ogTBUM7yYABn1ko7szMSnETJ74ofu08beLQ8xs7c/C4mMRvs6AxE28ULwcHIirLkYgicmRyKMRyIKNyiQOCyi88LSJRV1YZTWCjqJxakg6NWFaKxiQy4OQSC8XJr1xx8QvJgIs/Mj4CafAmREce6MgTIHASgfcpjWAAAAAASUVORK5CYII="
            class="icon"
          /><span>{{ $t('recharge_completed') }}</span>
        </div>
        <div data-v-334775a8="" class="seedetail-button" @click="$parent.goNav('/transRecord')">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAAOVBMVEUMqIcPqIYOqIUOqIYPqIUAr4ALqoVHcEwPp4YOqYcNp4UPqIYPp4UOqIYOqIUIp4cNqYYOqIUPqIbGVSZiAAAAEnRSTlM/0JBw8BAwAMB/YN/goG8gULADspVqAAAAtklEQVQoz42S2xbEEAxFg0hCbzP5/48d2lqL0mnPm2xHboDZL5NeZCwnAW+oA5mdfXX+wEURNWSmCtwpqiRGqj1iyFGAJxZDo1gzaYuUmllpZN/mo7Y9epvvHxvrmZ1v5oBfZZLgR4yOXSLxpYfkMooWHCr6Lp87HH5W2zFRe94xAxarmdGNT7o/UfKd/2VRXKHUyXudAXcD5LKLcn/llPy5JydYzcWl5YYt+QluZplem+8Ye6EfKyMbAQTPPjYAAAAASUVORK5CYII="
            class="icon"
          /><span>{{ $t('fund_details') }}</span>
        </div>
      </div>
      <!---->
    </div>

    <div data-v-f531b812="" class="float-divbox"></div>
    <span data-v-7b0f8a3e="" data-v-f531b812="" class="customer-service-container"></span><span data-v-f531b812=""></span>
    <div data-v-55ec3770="" data-v-f531b812="" class="select-service-line-view select-service-line-view">
      <dl data-v-55ec3770="" class="select-service-list"><div data-v-55ec3770="" style="height: 55px"></div></dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payInfo',
  data() {
    return {
      payInfo: {},
      type: null,
      daoTime: null,
      m: 0,
      s: 0,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.deposit_no) {
      that.getpayinfo(query.deposit_no);
    }
  },
  methods: {
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$parent.showTost(1, this.$t('copy_success'));
    },
    getpayinfo(deposit_no) {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log('payinfo返回:', res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.payInfo = res.data;
          that.type = res.message;
          that.countTime();
        }
        this.$parent.hideLoading();
      });
    },
    countTime() {
      let that = this;
      var date = new Date();
      var now = date.getTime();
      if (!that.payInfo.info) return;
      let created_at = that.payInfo.info.created_at;
      let createdTime = new Date(created_at).getTime();
      var end = createdTime + 1000 * 60 * 60;
      var leftTime = end - now;

      if (leftTime >= 0) {
        that.m = Math.floor((leftTime / 1000 / 60) % 60);
        that.s = Math.floor((leftTime / 1000) % 60);
      } else {
        clearInterval(that.countTime);
        that.countTime = null;
        return;
      }
      let m = that.m >= 10 ? that.m : `0${that.m}`;
      let s = that.s >= 10 ? that.s : `0${that.s}`;
      setTimeout(this.countTime, 1000);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.countTime) {
      clearInterval(that.countTime);
    }
    that.countTime = null;
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/fund-recharge-info.dba269b9.css';

/* 金额样式 */
.PayAmount {
  text-align: center;
  padding: 15px 0 10px;
  
  .currency-symbol {
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin-right: 4px;
  }
  
  .Amount {
    font-size: 36px;
    font-weight: bold;
    color: #e70620;
  }
}

/* USDT信息行 */
.usdt-info-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 8px 0;
  background: #f8f9ff;
  border-radius: 30px;
  margin: 10px 0;
  
  .UsdtAmount {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 500;
    color: #3e40ea;
    
    .usdt-icon {
      font-size: 16px;
    }
  }
  
  .ExchangeRate {
    font-size: 13px;
    color: #ff9800;
    font-weight: 500;
  }
}

/* 倒计时样式 */
.Countdown {
  text-align: center;
  padding: 15px 0 10px;
  
  .countdown-box {
    background: #f0f0f0;
    border-radius: 30px;
    padding: 8px 16px;
    display: inline-block;
    
    .countdown-label {
      font-size: 14px;
      color: #666;
      margin-right: 8px;
    }
    
    .countdown-time {
      font-size: 18px;
      font-weight: bold;
      color: #ff6b6b;
    }
  }
}

/* 提示信息 */
.auto-credit-tip {
  text-align: center;
  font-size: 13px;
  color: #52c41a;
  padding: 8px 0;
}

.contact-tip {
  text-align: center;
  font-size: 12px;
  color: #999;
  padding: 8px 0;
  
  .contact-customer {
    color: #3e40ea;
    font-weight: 500;
    text-decoration: underline;
  }
}

/* 交易详情卡片 */
.transaction-detail {
  background: #fff;
  border-radius: 16px;
  margin-top: 15px;
  padding: 0 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
  
  .detail-label {
    font-size: 14px;
    color: #999;
    min-width: 90px;
  }
  
  .detail-value {
    font-size: 14px;
    color: #333;
    text-align: right;
    word-break: break-all;
    flex: 1;
  }
  
  .method-value {
    color: #3e40ea;
    font-weight: 500;
  }
  
  .protocol-value {
    color: #ff9800;
    font-weight: 500;
  }
}

/* 地址样式 */
.address-item {
  .address-value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    
    .address-text {
      font-size: 13px;
      color: #333;
      font-family: monospace;
      letter-spacing: 0.5px;
      word-break: break-all;
      max-width: 200px;
    }
    
    .copy-btn {
      background: #3e40ea;
      color: #fff;
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.3s;
      white-space: nowrap;
      
      &:hover {
        background: #2a2cb8;
      }
    }
  }
}

.order-text {
  font-family: monospace;
  font-size: 13px;
  letter-spacing: 0.5px;
}

/* 二维码样式 */
.qrcode-wrapper {
  text-align: center;
  padding: 20px 0;
  
  .qrcode-label {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
  }
  
  .qrcode-image {
    width: 200px;
    height: 200px;
    display: inline-block;
    margin: 0 auto;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

/* 底部按钮 */
.footer {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 20px;
  padding-bottom: 20px;
  
  .goback-button,
  .seedetail-button {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 0;
    border-radius: 30px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    
    .icon {
      width: 20px;
      height: 20px;
    }
  }
  
  .goback-button {
    background: #f5f5f5;
    color: #666;
    
    &:hover {
      background: #e8e8e8;
    }
  }
  
  .seedetail-button {
    background: linear-gradient(135deg, #3e40ea, #5a77ef);
    color: #fff;
    
    &:hover {
      background: linear-gradient(135deg, #2a2cb8, #3e40ea);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/payInfo.vue